import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getFlagOfOrder as P } from "./utils.js";
import { call as s } from "../../_utils/vue/call.js";
import { ref as j } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { computed as O } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function c(o) {
  return typeof o == "object" && typeof o.multiple == "number" ? o.multiple : !1;
}
function k(o, l) {
  return l && (o === void 0 || o === "default" || typeof o == "object" && o.compare === "default") ? w(l) : typeof o == "function" ? o : o && typeof o == "object" && o.compare && o.compare !== "default" ? o.compare : !1;
}
function w(o) {
  return (l, d) => {
    const f = l[o], i = d[o];
    return f == null ? i == null ? 0 : -1 : i == null ? 1 : typeof f == "number" && typeof i == "number" ? f - i : typeof f == "string" && typeof i == "string" ? f.localeCompare(i) : 0;
  };
}
function B(o, {
  dataRelatedColsRef: l,
  filteredDataRef: d
}) {
  const f = [];
  l.value.forEach((e) => {
    var r;
    e.sorter !== void 0 && v(f, {
      columnKey: e.key,
      sorter: e.sorter,
      order: (r = e.defaultSortOrder) !== null && r !== void 0 ? r : !1
    });
  });
  const i = j(f), a = O(() => {
    const e = l.value.filter((n) => n.type !== "selection" && n.sorter !== void 0 && (n.sortOrder === "ascend" || n.sortOrder === "descend" || n.sortOrder === !1)), r = e.filter((n) => n.sortOrder !== !1);
    if (r.length)
      return r.map((n) => ({
        columnKey: n.key,
        // column to sort has controlled sorter
        // sorter && sort order won't be undefined
        order: n.sortOrder,
        sorter: n.sorter
      }));
    if (e.length)
      return [];
    const {
      value: t
    } = i;
    return Array.isArray(t) ? t : t ? [t] : [];
  }), h = O(() => {
    const e = a.value.slice().sort((r, t) => {
      const n = c(r.sorter) || 0;
      return (c(t.sorter) || 0) - n;
    });
    return e.length ? d.value.slice().sort((t, n) => {
      let u = 0;
      return e.some((U) => {
        const {
          columnKey: F,
          sorter: N,
          order: S
        } = U, g = k(N, F);
        return g && S && (u = g(t.rawNode, n.rawNode), u !== 0) ? (u = u * P(S), !0) : !1;
      }), u;
    }) : d.value;
  });
  function b(e) {
    let r = a.value.slice();
    return e && c(e.sorter) !== !1 ? (r = r.filter((t) => c(t.sorter) !== !1), v(r, e), r) : e || null;
  }
  function p(e) {
    const r = b(e);
    y(r);
  }
  function y(e) {
    const {
      "onUpdate:sorter": r,
      onUpdateSorter: t,
      onSorterChange: n
    } = o;
    r && s(r, e), t && s(t, e), n && s(n, e), i.value = e;
  }
  function x(e, r = "ascend") {
    if (!e)
      m();
    else {
      const t = l.value.find((u) => u.type !== "selection" && u.type !== "expand" && u.key === e);
      if (!(t != null && t.sorter))
        return;
      const n = t.sorter;
      p({
        columnKey: e,
        sorter: n,
        order: r
      });
    }
  }
  function m() {
    y(null);
  }
  function v(e, r) {
    const t = e.findIndex((n) => (r == null ? void 0 : r.columnKey) && n.columnKey === r.columnKey);
    t !== void 0 && t >= 0 ? e[t] = r : e.push(r);
  }
  return {
    clearSorter: m,
    sort: x,
    sortedDataRef: h,
    mergedSortStateRef: a,
    deriveNextSorter: p
  };
}
export {
  B as useSorter
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/use-sorter.js
// module id = 1664
// module chunks = 67